import React, { useEffect, useState } from "react";
import { RecruitRow1 } from "../components/DataRow";
// import CityDropdowns from '../components/CityDropdowns';
import Navbar from "../components/Navbar";

const KeywordSearch = () => {
  const [list, setList] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [flag, setFlag] = useState(true);
  const search = () => {
    fetch("/api/campus/", {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        city: "",
        category1: true,
        category2: true,
        keyword: keyword,
        page: page,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.content) {
          setList(res.content);
        } else {
          console.info(res.message);
        }
      });
  };
  const handleChange = (event) => {
    setKeyword(event.target.value);
  };
  const _οnkeypress = (event) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 13 && event.target.value !== "") {
      search({
        keyword: event.target.value,
      });
    }
  };
  const load = () => {
    fetch("/api/campus/", {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        city: "",
        keyword: keyword,
        category1: true,
        category2: true,
        page: page + 1,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.content.length) {
          setList(list.concat(res.content));
          setFlag(true);
          setPage(page + 1);
        } else {
          setFlag(true);
          alert("已经到底了");
          document.getElementById("load").innerHTML = "已经到底了";
          document.getElementById("load").disabled = true;
        }
      });
    setFlag(false);
  };

  useEffect(() => {
    document.title = "校园招聘查询";
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row pb-2 pt-1 bg-transparent">
          <div className="col">
            <input
              type="text"
              id="search"
              className="w-100 border-0 text-center rounded-pill"
              placeholder="按照企业/学校名称查询"
              onChange={handleChange}
              onKeyPress={_οnkeypress}
              autoFocus
              style={{ outline: 0, height: 35 }}
            />
          </div>
        </div>
        <div className="card border-0 user-radius shadow">
          <div className="card-body">
            <div className="row mb-3" style={{ fontSize: 14 }}>
              <div className="col">{/* <CityDropdowns handleChange={handleChange} /> */}</div>
            </div>
            {list && list.map((item) => <RecruitRow1 key={item.id} {...item} />)}
            {flag === true ? (
              <button id="load" className="btn btn-block mx-auto" onClick={load}>
                点击加载更多
              </button>
            ) : (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Navbar category="校园招聘" />
    </>
  );
};

export default KeywordSearch;
